<template>
    <div class="add-box">
        <el-dialog
            v-model="dialogVisible"
            :title="title"
            width="40%"
            :before-close="handleClose"
        >
            <el-form ref="form" :model="Dform" :rules="rules" label-width="80px" >
                <el-row>
                    <el-form-item label="一级管理员" prop="region">
                        <el-select v-model="Dform.region" filterable placeholder="请选择学校" @change="schoolClick">
                            <el-option :label="item.name" :value="item.id" v-for="item in schoolList" :key="item.value"  ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户名" prop="username" v-if="this.titleValue == '一级管理员修改' || this.titleValue == '二级管理员修改' || this.titleValue == '三级管理员修改'">
                        <el-input v-model="Dform.username"   :disabled="true" ></el-input>
                    </el-form-item>
                    <el-form-item label="用户名" prop="username" v-else>
                        <el-input v-model="Dform.username" ></el-input>
                    </el-form-item>
                    <el-form-item label="二级管理员 " prop="classes" v-if="title != '新增二级管理员' && title != '二级级管理员修改'">
                        <el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick">
                            <el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设置密码" prop="setPassword">
                        <el-input v-model="Dform.setPassword" type="password" ></el-input>
                    </el-form-item>
          
                    <el-form-item label="三级管理员" prop="classes2" v-if="title == '新增三级管理员' || title == '三级管理员修改'">
                        <el-select v-model="Dform.classes2" filterable placeholder="请选择班级">
                            <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input v-model="Dform.confirmPassword" type="password" ></el-input>
                    </el-form-item>
                  
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="Dform.name" ></el-input>
                    </el-form-item>
                    <el-form-item label="教师编号" prop="teacherNumber">
                        <el-input v-model="Dform.teacherNumber" ></el-input>
                    </el-form-item>

                    <el-form-item label="手机" class="mobileStyle"  prop="handset">
                        <el-input v-model="Dform.handset" ></el-input>
                    </el-form-item>
                    <el-form-item label="职称" prop="positionalTitles">
                        <el-input v-model="Dform.positionalTitles" ></el-input>
                    </el-form-item>
             
                    <el-form-item label="年龄" prop="age">
                        <el-input v-model="Dform.age" ></el-input>
                    </el-form-item>
          
                     <el-form-item label="电话" >
                        <el-input v-model="Dform.telephone" ></el-input>
                    </el-form-item>
                    <el-form-item label="地址" >
                        <el-input v-model="Dform.address" ></el-input>
                    </el-form-item>
                    <el-form-item label="性别" >
                        <el-radio-group v-model="Dform.sex">
                            <el-radio label="男" ></el-radio>
                            <el-radio label="女" ></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <!-- <el-row >
                    <el-form-item label="班级" prop="classes" v-if="title != '新增学校管理员' && title != '一级管理员修改'">
                        <el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick">
                            <el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="classes2" v-if="title == '新增班级管理员' || title == '三级管理员修改'">
                        <el-select v-model="Dform.classes2" filterable placeholder="请选择班级">
                            <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-row> -->
                <!-- <el-row>
                    <el-form-item label="设置密码" prop="setPassword">
                        <el-input v-model="Dform.setPassword" type="password" ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input v-model="Dform.confirmPassword" type="password" ></el-input>
                    </el-form-item>
                </el-row> -->
                <!-- <el-row>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="Dform.name" ></el-input>
                    </el-form-item>
                    <el-form-item label="教师编号" prop="teacherNumber">
                        <el-input v-model="Dform.teacherNumber" ></el-input>
                    </el-form-item>
                </el-row> -->
                <!-- <el-row>
                    <el-form-item label="职称" prop="positionalTitles">
                        <el-input v-model="Dform.positionalTitles" ></el-input>
                    </el-form-item>
                    <el-form-item label="年龄" prop="age">
                        <el-input v-model="Dform.age" ></el-input>
                    </el-form-item>
                </el-row> -->
                <!-- <el-row>
                    <el-form-item label="性别" >
                        <el-radio-group v-model="Dform.sex">
                            <el-radio label="男" ></el-radio>
                            <el-radio label="女" ></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机" class="mobileStyle" >
                        <el-input v-model="Dform.handset" ></el-input>
                    </el-form-item>
                </el-row>
       -->
                <el-row>
                    <!-- <el-form-item label="电话" >
                        <el-input v-model="Dform.telephone" ></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="地址" >
                        <el-input v-model="Dform.address" ></el-input>
                    </el-form-item> -->
                </el-row>
                <!-- <el-row>
                    <el-form-item label="短信额度" >
                        <el-input v-model="Dform.smsQuota" ></el-input>
                    </el-form-item>
                    <el-form-item label="已用额度" >
                        <el-input v-model="Dform.alreadyUsed" ></el-input>
                    </el-form-item>
                </el-row>
             -->
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="handleClose">返回</el-button>
                    <el-button type="primary" class="formClick" @click="submitForm('form')">
                    提交
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { addTeacherInfo,addGrade,addClass,school,gradeList,findClassList,updateTeacherInfo} from '@/assets/api/renyuan';
export default {
    props: ['titleValue','detailsObj'],
    components: {

    },
    data() {
        return {
            Dform: {
                region: '',
                username: '',
                setPassword: '',
                confirmPassword: '',
                name: '',
                teacherNumber: '',
                positionalTitles: '',
                age: '',
                // postbox: '',
                handset: '',
                telephone: '',
                address: '',
                smsQuota:0,
                alreadyUsed: 0,
                classes: '',
                classes2: '',
                studentId: '',
                parentsCall: '',
                parentsCall2: '',
                parentsCall3: '',
                sex: '男',
                Nfc:'',
                Imei: '',
                international: '',
            },
            dialogVisible: true,
            title: '',
            schoolList: [],
            gradeDataList: [],
            classList: [],
            rules: {
                // imei: [
                //     { required: true, message: '请输入IMEI', trigger: 'blur' },
                // ],
                region: [
                    { required: true, message: '请选学校', trigger: 'change' }
                ],
                classes: [
                    { required: true, message: '请选班级', trigger: 'change' }
                ],
                classes2: [
                    { required: true, message: '请选班级', trigger: 'change' }
                ],
                username: [
                    { required: true, message: '请输入用户名', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'change' }
                ],
                handset: [
                    { required: true, message: '请输入手机', trigger: 'change' }
                ],
            },
        };
    },
    created() {
        this.title = this.titleValue
        if ( this.titleValue == '一级管理员修改' || this.titleValue == '二级管理员修改' || this.titleValue == '三级管理员修改') {
            console.log(JSON.stringify(this.detailsObj),'修改页');
            this.Dform.address = this.detailsObj.address // 地址
            this.Dform.age = this.detailsObj.age // 
            this.Dform.confirmPassword = this.detailsObj.checkPassword // 确认密码
            this.Dform.classes2 =this.detailsObj.classId // 班级
            this.Dform.classes =this.detailsObj.gradeId // '年级id'
            this.Dform.region = this.detailsObj.schoolId // 学校id
            this.Dform.teacherNumber = this.detailsObj.code // 编号
            // this.Dform.postbox = this.detailsObj.email // 邮箱
            this.Dform.smsQuota = this.detailsObj.maxSms // 短信额度
            this.Dform.alreadyUsed = this.detailsObj.usedSms // 已用额度
            this.Dform.handset = this.detailsObj.mobile // 手机
            this.Dform.name = this.detailsObj.name // 姓名
            this.Dform.setPassword = this.detailsObj.password
            this.Dform.positionalTitles =  this.detailsObj.position
            this.Dform.sex =  this.detailsObj.sex =='0'? '女': '男' // 性别
            this.Dform.studentId = this.detailsObj.studentNo // 学号
            this.Dform.telephone = this.detailsObj.telephone // 电话
            this.Dform.username = this.detailsObj.username 
        }
        if (this.titleValue == '二级管理员修改' || this.titleValue == '三级管理员修改') {
            this.schoolClick(1)
        }
        if ( this.titleValue == '三级管理员修改' ) {
            this.classClick(1)
        }
    },
    mounted() {
        this.schoolPost()
    },
    methods: {
        classClick (vla) {
            if (vla != 1) { 
                this.Dform.classes2 = ''
            }
            let params = {
                page: '1',
                pageSize: '999',
            }
            findClassList(params,this.Dform.classes).then((res)=> {
                console.log(res,'班级列表');
                this.classList = res.data.data
            }).catch((err)=> {
                console.log(err);
            })
        },
        schoolClick (vla) {
            if (vla != 1) { 
                this.Dform.classes = ''
                this.Dform.classes2 = ''
            }
            let params = {
                page: '1',
                pageSize: '999',
            }
            gradeList(params,this.Dform.region).then((res)=> {
                this.gradeDataList = res.data.data
                // console.log(res,this.Dform.classes,'年级列表');
            }).catch((err)=> {
                console.log(err);
            })
        },
        schoolPost (schooName) {
            let params = {
                page: '1',
                pageSize: '999',
                schoolName: schooName || '',
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            school(params).then((res)=> {
                // console.log(res,'学校列表');
                this.schoolList = res.data.data.list
            }).catch((err)=> {
                console.log(err);
            })
        },
        submitForm(formName) {
            console.log(this.Dform,this.title);
            this.$refs[formName].validate((valid) => {
            if (valid) {
                console.log('校验通过');
                if ( this.title == '新增一级管理员' ) {
                    this.addTeacherInfo()
                    console.log('新增学校管理员');
                } else if (this.title == '新增二级管理员' ) {
                    console.log('新增年级管理员');
                    this.addGrade()
                } else if (this.title == '新增三级管理员' ) {
                    console.log('新增班级管理员');
                    this.addClass()
                } else if (this.title == '一级管理员修改' || this.title == '二级管理员修改' || this.title == '三级管理员修改' ) {
                    console.log('一级管理员修改');
                    this.updateTeacherInfo()
                }
            } else {
                console.log(valid,'校验未通过');
                return false;
            }
            });
        },
        handleClose () {
            this.$emit('addClick')
        },
        updateStudentInfoClick () {
            let params = {
                studentId: this.Dform.studentId,
                classId: this.detailsObj.classId,
                mobileOne: this.Dform.parentsCall,
                mobileTwo: this.Dform.parentsCall2,
                mobileThree: this.Dform.parentsCall3,
            }
            console.log(params,1111);
            updateStudentInfo(params).then((res)=> {
                console.log(res,4444);
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        // 学校管理员
        addTeacherInfo () {
            console.log(789);
            let params = {
                address: this.Dform.address, // 地址
                age: this.Dform.age, // 
                checkPassword: this.Dform.confirmPassword, // 确认密码
                // classId: this.Dform.classes2, // 班级
                // gradeId: this.Dform.region, // '年级id'
                schoolId: this.Dform.region, // 学校id
                code: this.Dform.teacherNumber, // 编号
                // email: this.Dform.postbox, // 邮箱
                maxSms: this.Dform.smsQuota, // 短信额度
                usedSms: this.Dform.alreadyUsed, // 已用额度
                mobile: this.Dform.handset, // 手机
                name: this.Dform.name, // 姓名
                password: this.Dform.setPassword,
                position: this.Dform.positionalTitles,
                sex: this.Dform.sex=='女'?'0':'1', // 性别
                // studentName: this.Dform.name, // 姓名
                studentNo: this.Dform.studentId, // 学号
                telephone: this.Dform.telephone, // 电话
                userName: this.Dform.username, 
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            addTeacherInfo(params).then((res)=> {
                console.log(res,'老师-新增');
                this.$message({type: 'success',message: '新增成功!'}); 
                this.handleClose()
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        //学校修改
        updateTeacherInfo () {
            let params = {
                address: this.Dform.address, // 地址
                age: this.Dform.age, // 
                checkPassword: this.Dform.confirmPassword, // 确认密码
                classId: this.title == '三级管理员修改'? this.Dform.classes2:null, // 班级
                gradeId: this.title == '二级管理员修改' || this.title == '三级管理员修改'? this.Dform.classes:null, // '年级id'
                schoolId: this.Dform.region, // 学校id
                code: this.Dform.teacherNumber, // 编号
                // email: this.Dform.postbox, // 邮箱
                maxSms: this.Dform.smsQuota, // 短信额度
                usedSms: this.Dform.alreadyUsed, // 已用额度
                mobile: this.Dform.handset, // 手机
                name: this.Dform.name, // 姓名
                password: this.Dform.setPassword,
                position: this.Dform.positionalTitles,
                sex: this.Dform.sex=='女'?'0':'1', // 性别
                // studentName: this.Dform.name, // 姓名
                studentNo: this.Dform.studentId, // 学号
                telephone: this.Dform.telephone, // 电话
                username: this.Dform.username, 
                id: this.detailsObj.id,
                loginUserId: JSON.parse(localStorage.getItem('user')).id,
            }
            updateTeacherInfo(params).then((res)=> {
                console.log(res,'老师-新增');
                this.$message({type: 'success',message: '修改成功!'}); 
                this.handleClose()
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        // 年级管理员
        addGrade () {
            let params = {
                address: this.Dform.address, // 地址
                age: this.Dform.age, // 
                checkPassword: this.Dform.confirmPassword, // 确认密码
                classId:null,
                gradeId:this.Dform.classes, // '年级id'
                schoolId: this.Dform.region, // 学校id
                code: this.Dform.teacherNumber, // 编号
                // email: this.Dform.postbox, // 邮箱
                maxSms: this.Dform.smsQuota, // 短信额度
                usedSms: this.Dform.alreadyUsed, // 已用额度
                mobile: this.Dform.handset, // 手机
                name: this.Dform.name, // 姓名
                password: this.Dform.setPassword,
                position: this.Dform.positionalTitles,
                sex: this.Dform.sex=='女'?'0':'1', // 性别
                studentName: this.Dform.name, // 姓名
                studentNo: this.Dform.studentId, // 学号
                telephone: this.Dform.telephone, // 电话
                userName: this.Dform.username, 
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            addTeacherInfo(params).then((res)=> {
                this.handleClose()
                this.$message({type: 'success',message: '新增成功!'}); 
                console.log(res);
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
        //班级管理员
        addClass () {
            let params = {
                address: this.Dform.address, // 地址
                age: this.Dform.age, // 
                checkPassword: this.Dform.confirmPassword, // 确认密码
                classId:this.Dform.classes2,
                // gradeId: this.Dform.classes2, // '年级id'
                gradeId: this.Dform.classes, // '年级id'
                schoolId: this.Dform.region, // 学校id
                code: this.Dform.teacherNumber, // 编号
                // email: this.Dform.postbox, // 邮箱
                maxSms: this.Dform.smsQuota, // 短信额度
                usedSms: this.Dform.alreadyUsed, // 已用额度
                mobile: this.Dform.handset, // 手机
                name: this.Dform.name, // 姓名
                password: this.Dform.setPassword,
                position: this.Dform.positionalTitles,
                sex: this.Dform.sex=='女'?'0':'1', // 性别
                // studentName: this.Dform.name, // 姓名
                studentNo: this.Dform.studentId, // 学号
                telephone: this.Dform.telephone, // 电话
                userName: this.Dform.username, 
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            addTeacherInfo(params).then((res)=> {
                this.handleClose()
                this.$message({type: 'success',message: '新增成功!'}); 
                console.log(res);
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
            })
        },
    },
};
</script>

<style scoped lang="scss">
.formClick{
// background-color: #1BC896;;
}
:deep() {
    .el-dialog__body {
        // height: 75%;
        max-height: 500px;
        // min-height: 350px;        
        overflow: auto;
    }
    .el-input--small {
        width: 250px;
    }
    .el-select .el-input__inner {
        height: 35px;
        line-height: 35px;
    }
    .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
    .el-input__inner {
        height: 35px;
        line-height: 35px; 
    }
    .el-radio.el-radio--small .el-radio__inner {
        width: 14px;
        height: 14px;
    }
    .el-input__wrapper {
        height: 35px;
        line-height: 35px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__wrapper {
        height: 35px !important;
    }
    .el-select--small .el-select__wrapper {
        width: 250px;
        height: 35px;
    }
    .mobileStyle{
        // width: 345px;
        // margin-left: 150px;

    }
}
</style>
